<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('queues.title')"></page-header-title>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="queues"
            :items-per-page="queues.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text'),
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
          >
            <template v-slot:item.available_at="{ item }">
              {{ moment.unix(item.available_at).format(MYSQL_DATETIME_FORMAT) }}
            </template>

            <template v-slot:item.created_at="{ item }">
              {{ moment(item.created_at).format(MYSQL_DATETIME_FORMAT) }}
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "LogList",

  data() {
    return {
      url: "",
      queues: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__page_Queue_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"],
        sortDesc: [false],
      },
      search_params: {},
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("queues.id"), value: "id" },
          { text: this.$t("queues.queue"), value: "queue" },
          { text: this.$t("queues.payload"), value: "payload" },
          { text: this.$t("queues.attempts"), value: "attempts" },
          { text: this.$t("queues.available_at"), value: "available_at" },
          { text: this.$t("queues.created_at"), value: "created_at" },
        ]
      },
    },
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      },
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) ||
              !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc,
            }
            localStorage.setItem("__sort_Queue_List", JSON.stringify(obj))
          }

          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_Queue_List", newVal.page)
          }

          this.refresh = true
        }
      },
    },
  },

  mounted() {
    this.url = this.API_URL + "queues"
  },

  methods: {
    list() {
      this.show_loading = true

      let localFilter = localStorage.getItem("__filter_Queue_List")
      if (localFilter !== null) {
        localFilter = JSON.parse(localFilter)
        this.search_params = localFilter
      }

      let localSort = localStorage.getItem("__sort_Queue_List")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let query = this.$queryString(this.pagination, this.search_params)

      axios
        .get(this.url + "?" + query)
        .then(res => {
          this.queues = res.data.data
          this.total = res.data.meta.total
          this.refresh = false
          this.show_loading = false

          this.pagination.page = res.data.meta.current_page
          this.pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch(err => console.log(err))
    },

    filter() {
      this.pagination.page = 1
      this.refresh = true
      localStorage.setItem(
        "__filter_Queue_List",
        JSON.stringify(this.search_params),
      )
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },
  },
}
</script>

<style scoped></style>
